import { useServiceFilter } from '../../../hooks/InvoiceHooks';
import { WP_Service } from '../../../model/models';
import { ServicesProps } from '../../../pages/ServicesPage';
import { ServiceItem } from './ServiceItem';

/**
 * Services Menu
 * @param props
 * @returns
 */
export const ServicesMenu: React.FC<ServicesProps> = ({ services }) => {
  const serviceFilter = useServiceFilter();
  return (
    <div className="w-full text-left">
      <ul className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {services
          ? services.filter(serviceFilter).map((service: WP_Service, index) => {
              return <ServiceItem key={index} service={service} />;
            })
          : ''}
      </ul>
    </div>
  );
};
export default ServicesMenu;
